import gql from 'graphql-tag';

export default gql`
  mutation deliveryNoteCreate($text: String!) {
    deliveryNoteCreate(text: $text) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
